import React from 'react'
import TopNav from '../nav/TopNav';
import Footer from '../footer/Footer';
import '../../assets/styles/style.scss'
import Contact from './Contact';
import { AppleLogo, GooglePlay } from '../../assets/icons/IconComponents';
import CategoriesPart from './CategoriesPart';
import { useTranslation } from 'react-i18next';


export default function Homepage() {
  const { t } = useTranslation()
  
  const onDownloadLink = (code) => {
    if(code == 'ios') {
      window.open('https://apps.apple.com/app/id6740991708', '_blank')
    
    } else if(code == 'android') {
      window.open('https://play.google.com/store/apps/details?id=com.feenta.appfeenta', '_blank')
      
    }
  }


  return (
    <>
      <TopNav />
      <div className="fx top-body">
        <div className="left-part">
          <h2>{t('activities_platform_info')}</h2>
          <span className="subtitle-s">
          {t('no_matter_passion_info')}
          </span>
          <br />
          <br />
          <span>
          {t('discover_events_info')}
          </span>
        </div>
        <div className="right-part">
          <span className="download-container" onClick={() => onDownloadLink('ios')}>
            <AppleLogo />
            {t('download_app_store')}
          </span>
          <span className="download-container" onClick={() => onDownloadLink('android')}>
            <GooglePlay />
            {t('download_google_play')}
          </span>
        </div>
      </div>
      <CategoriesPart />
      <Contact />
      <Footer />
    </>
  );
}

